/* Hotaru: lykten du kan trekke i, ildfluer, kjøpslinje. Ren JavaScript, ingen avhengigheter. */
(function () {
  'use strict';
  var root = document.querySelector('.ht');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Lykten: lag som glir jevnt mellom tre stopp ---------- */
  var room = root.querySelector('.room');
  var stage = root.querySelector('.stage');
  var callout = root.querySelector('.callout');
  var HS = [5.5, 32, 64.5];                     // skjermens høyde i prosent av lykten, tre stopp
  var LAST = HS.length - 1;
  var NAVN = ['Sammenbrettet', 'Litt ut', 'Helt ut'];
  var SUB = ['6,3 cm', 'ved sengen', 'i vinduet'];
  var cur = 0, curH = HS[0], touched = false, swapT = null;
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  function setH(h, instant) {
    curH = Math.max(HS[0], Math.min(HS[LAST], h));
    if (!stage) return;
    stage.style.setProperty('--dur', instant ? '0s' : '');
    stage.style.setProperty('--h', curH.toFixed(2) + '%');
    root.style.setProperty('--lift', ((curH - HS[0]) / (HS[LAST] - HS[0])).toFixed(3));
  }
  function nearest(h) {
    var best = 0, d = 1e9;
    HS.forEach(function (s, k) { var dd = Math.abs(s - h); if (dd < d) { d = dd; best = k; } });
    return best;
  }
  function label(k) {
    if (!callout) return;
    var b = callout.querySelector('b'), s = callout.querySelector('small');
    if (b.textContent === NAVN[k]) return;
    callout.classList.add('swap');
    clearTimeout(swapT);
    swapT = setTimeout(function () { b.textContent = NAVN[k]; s.textContent = SUB[k]; callout.classList.remove('swap'); }, 320);
  }
  function go(k, instant) {
    k = Math.max(0, Math.min(LAST, k));
    cur = k;
    setH(HS[k], instant);
    if (stage) { stage.setAttribute('aria-valuenow', String(k + 1)); stage.setAttribute('aria-valuetext', NAVN[k]); }
    label(k);
  }
  function markTouched() { touched = true; if (room) room.classList.add('touched'); pauseAuto(); }

  /* Går opp og ned av seg selv til noen rører den */
  var autoT = null, resumeT = null, dir = 1, autoOn = !reduce;
  function autoStep() {
    if (!autoOn) return;
    var k = cur + dir;
    if (k > LAST) { dir = -1; k = LAST - 1; }
    if (k < 0) { dir = 1; k = 1; }
    go(k);
    autoT = setTimeout(autoStep, k === LAST || k === 0 ? 2600 : 1900);
  }
  function pauseAuto() {
    autoOn = false; clearTimeout(autoT); clearTimeout(resumeT);
    if (!reduce) resumeT = setTimeout(function () { autoOn = true; dir = cur >= LAST ? -1 : 1; autoStep(); }, 12000);
  }

  if (stage) {
    if (reduce) { go(LAST, true); }
    else {
      go(0, true);
      if ('IntersectionObserver' in window) {
        var started = false;
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting && !started) { started = true; autoT = setTimeout(autoStep, 900); }
        }, { threshold: 0.4 });
        io.observe(stage);
      } else { autoT = setTimeout(autoStep, 900); }
    }

    var dragging = false, y0 = 0, h0 = 0, ph = 1, moved = false;
    // Trykk uten å dra: neste høyde (på mobil er dette eneste måten).
    stage.addEventListener('click', function () { if (moved) return; markTouched(); go(cur >= LAST ? 0 : cur + 1); });
    stage.addEventListener('pointerdown', function (e) {
      moved = false;
      if (coarse) return;
      dragging = true; y0 = e.clientY; h0 = curH; ph = stage.getBoundingClientRect().height || 1;
      stage.classList.add('dragging'); markTouched();
      try { stage.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = y0 - e.clientY;                       // oppover = positiv
      if (Math.abs(dy) > 6) moved = true;
      setH(h0 + dy / ph * 100, true);                // 1 px drag = 1 px lykt
      label(nearest(curH));
    });
    function end() {
      if (!dragging) return;
      dragging = false; stage.classList.remove('dragging');
      go(nearest(curH));
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('lostpointercapture', end);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowRight') { e.preventDefault(); markTouched(); go(cur + 1); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowLeft') { e.preventDefault(); markTouched(); go(cur - 1); }
      if (e.key === 'Home') { e.preventDefault(); markTouched(); go(0); }
      if (e.key === 'End') { e.preventDefault(); markTouched(); go(LAST); }
    });
  }

  /* ---------- Ildfluer (hotaru) ---------- */
  var cv = root.querySelector('canvas.fireflies');
  if (cv && !reduce && cv.getContext) {
    var ctx = cv.getContext('2d'), W = 0, H = 0, flies = [], raf = null, visible = true;
    function size() {
      var r = cv.parentElement.getBoundingClientRect();
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = W < 750 ? 14 : 26;
      flies = [];
      for (var i = 0; i < n; i++) flies.push(mk(true));
    }
    function mk(any) {
      return { x: Math.random() * W, y: any ? Math.random() * H : H + 10, r: 1 + Math.random() * 1.6,
        vx: (Math.random() - .5) * .25, vy: -(.08 + Math.random() * .22), ph: Math.random() * Math.PI * 2, sp: .6 + Math.random() * 1.2, life: 0 };
    }
    function tick(ts) {
      if (!visible) { raf = null; return; }
      ctx.clearRect(0, 0, W, H);
      var lift = parseFloat(getComputedStyle(root).getPropertyValue('--lift')) || 0;
      for (var i = 0; i < flies.length; i++) {
        var f = flies[i];
        f.x += f.vx + Math.sin(ts / 900 + f.ph) * .18; f.y += f.vy; f.life += .016;
        var a = (0.35 + 0.65 * (0.5 + 0.5 * Math.sin(ts / 600 * f.sp + f.ph))) * (0.45 + lift * .55);
        if (f.y < -10 || f.x < -10 || f.x > W + 10) { flies[i] = mk(false); continue; }
        var g = ctx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 5);
        g.addColorStop(0, 'rgba(255,214,140,' + (a * .9).toFixed(3) + ')');
        g.addColorStop(.35, 'rgba(242,179,90,' + (a * .35).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(242,179,90,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(f.x, f.y, f.r * 5, 0, Math.PI * 2); ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    size(); window.addEventListener('resize', size);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
        if (visible && !raf) raf = requestAnimationFrame(tick);
      }).observe(cv);
    }
    raf = requestAnimationFrame(tick);
    document.addEventListener('visibilitychange', function () { if (document.hidden) visible = false; else { visible = true; if (!raf) raf = requestAnimationFrame(tick); } });
  }

  /* ---------- Antall og kjøp ---------- */
  var buy = root.querySelector('.buy form[data-kjop]');
  if (buy) {
    var vid = buy.getAttribute('data-variant');
    var price = parseInt(buy.getAttribute('data-price') || '0', 10); // i øre
    var cartUrl = buy.getAttribute('data-cart') || '/cart';
    var qtyInputs = buy.querySelectorAll('input[name="quantity"]');
    var link = root.querySelectorAll('a[data-kasse]');
    var total = root.querySelector('[data-total]');
    function fmt(ore) { var kr = Math.round(ore / 100); return kr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr'; }
    function upd() {
      var q = 1;
      qtyInputs.forEach(function (r) { if (r.checked) q = parseInt(r.value, 10) || 1; });
      link.forEach(function (a) { a.setAttribute('href', cartUrl + '/' + vid + ':' + q); });
      if (total) total.textContent = fmt(price * q);
    }
    qtyInputs.forEach(function (r) { r.addEventListener('change', upd); });
    upd();
  }

  /* ---------- Klistret linje på mobil ---------- */
  var bar = root.querySelector('.bar');
  var heroCta = root.querySelector('.hero .cta');
  if (bar && heroCta && 'IntersectionObserver' in window) {
    var buyBox = root.querySelector('.buy');
    var heroSeen = true, buySeen = false;
    function setBar() { var on = !heroSeen && !buySeen; bar.classList.toggle('show', on); if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', ''); }
    new IntersectionObserver(function (en) { heroSeen = en[0].isIntersecting; setBar(); }).observe(heroCta);
    if (buyBox) new IntersectionObserver(function (en) { buySeen = en[0].isIntersecting; setBar(); }, { threshold: .15 }).observe(buyBox);
  }

  /* ---------- Myk rulling til kjøp ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1); var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });
})();
